import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {Page} from "../../orchestration/page";
import {ButtonProminence} from "../../buttons/button/button";
import {NotificationService} from "../../notification/notification.service";
import {MessageLayout, MessageLevel} from "../../notification/message/message";
import {IdentityModel} from "../../identity/identity.model";
import {DealModel} from "../deal.model";
import {FormComponent} from "../../inputs/form/form.component";
import {NavigationParams} from "../../orchestration/navigation-params";
import {EntitlementResult, EntitlementResultCode} from "../entitlement-entity.model";

@Component({
    selector: "woa-deal-code-entry-page",
    templateUrl: "./deal-code-entry-page.component.html",
    providers: [{provide: Page, useExisting: DealCodeEntryPageComponent}]
})
export class DealCodeEntryPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    ButtonProminence = ButtonProminence;
    EntitlementStatus = EntitlementResultCode;
    MessageLevel = MessageLevel;
    MessageLayout = MessageLayout;

    dealCode: string;
    ordering: boolean = false;
    result: EntitlementResult;

    constructor(navigationParams: NavigationParams,
                public navigationService: NavigationService,
                public dealModel: DealModel,
                private identityModel: IdentityModel,
                private notificationService: NotificationService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    get showCode(): boolean {
        return !this.dealModel.currentEntitlement && !this.ordering && (!this.result || this.result.resultCode === EntitlementResultCode.DECLINED || this.result.resultCode === EntitlementResultCode.UNAVAILABLE);
    }

    get codeInputMode(): "text" | "numeric" {
        return this.identityModel.currentMember.anySelectByNonNumericDealCodeInApp ? "text" : "numeric";
    }

    get dealCodesAvailable(): boolean {
        return this.identityModel.currentMember && this.identityModel.currentMember.anySelectByDealCodeInApp;
    }

    async removeDeal(): Promise<any> {
        if (this.dealModel.currentEntitlement.products && this.dealModel.currentEntitlement.products.length &&
            !await this.notificationService.displayConfirmation("woa.heading.order.confirmRemoveDeal", undefined, "woa.message.order.confirmRemoveDeal",
                "woa.button.common.noThanks", "woa.button.order.removeDeal", true)) {
            return;
        }
        this.dealModel.removeCurrentEntitlement();
        if (!this.dealCodesAvailable) {
            return this.navigationService.dismissPage(this);
        }
    }

    async applyDealCode(): Promise<any> {
        this.dealCode = this.dealCode.trim();

        this.result = undefined;
        if (!this.form.valid) {
            return;
        }

        this.ordering = true;
        try {
            this.result = await this.dealModel.orderDealByDealCode(this.dealCode);
            if (this.result.resultCode === EntitlementResultCode.IMMEDIATE || this.result.resultCode === EntitlementResultCode.DEFERRED) {
                return this.navigationService.dismissPage(this, this.result);
            }
        } finally {
            this.ordering = false;
            this.changeDetectorRef.detectChanges();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/deal/deal-code-entry-page/deal-code-entry-page.component.ts